package org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media

import androidx.compose.runtime.Composable
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager
import org.hs_soft.runmynesto.domain.util.helper.Strings

enum class DisplaySizeEnum(val value: String) {
    STANDARD(value = ""),
    SELF_CHECKOUT(value = "");

    @Composable
    fun getTitle(): String {
        val strings = Strings.current()
        return when (this) {
            STANDARD -> strings.standard_1024_600
            SELF_CHECKOUT -> strings.selfCheckout_1080_1920
        }
    }

    val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                STANDARD -> strings.standard_1024_600
                SELF_CHECKOUT -> strings.selfCheckout_1080_1920
            }
        }
}